import type { ToolbarArray } from "./types";

export const IMAGE_MAX_BYTES_BASE64 = 1048576;

const PRME_COLORS = [
  "#1e3250",
  "#405dab",
  "#5b92e5",
  "#486c37",
  "#e2780e",
  "#dd0612",
  "#777d87",
];

/** Quill's stock palette (`themes/base.js`), five rows of seven. */
const QUILL_COLORS = [
  "#000000",
  "#e60000",
  "#ff9900",
  "#ffff00",
  "#008a00",
  "#0066cc",
  "#9933ff",
  "#ffffff",
  "#facccc",
  "#ffebcc",
  "#ffffcc",
  "#cce8cc",
  "#cce0f5",
  "#ebd6ff",
  "#bbbbbb",
  "#f06666",
  "#ffc266",
  "#ffff66",
  "#66b966",
  "#66a3e0",
  "#c285ff",
  "#888888",
  "#a10000",
  "#b26b00",
  "#b2b200",
  "#006100",
  "#0047b2",
  "#6b24b2",
  "#444444",
  "#5c0000",
  "#663d00",
  "#666600",
  "#003700",
  "#002966",
  "#3d1466",
];

export const RICH_TEXT_COLORS = [...PRME_COLORS, ...QUILL_COLORS];

export const DEFAULT_RICH_TEXT_TOOLBAR: ToolbarArray = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ["bold", "italic", "underline", "strike", "blockquote"],
  [{ color: RICH_TEXT_COLORS }, { background: RICH_TEXT_COLORS }],
  [{ script: "sub" }, { script: "super" }],
  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
  ["link", "formula", "image"],
  [{ align: "center" }, { align: "right" }],
  ["code-block"],
  ["table-better"],
  ["clean"],
];
